export default "__VITE_ASSET__DxEDVTj4__"